import { ComponentCanDeactivate } from '../component-can-deactivate';
import { Directive } from "@angular/core";

@Directive()
export abstract class SaisieCanDeactivate extends ComponentCanDeactivate {

    abstract get modificationEnCours(): boolean;

    canDeactivate(): boolean {
        return !this.modificationEnCours;
    }
}